import {  UploadCloud } from "react-feather";

export default [
    {
        id:"register-docs",
        title:"Registrasi Dokumen",
        icon:<UploadCloud size={20} />,
        navLink:"/register-docs",
    }
]